// extracted by mini-css-extract-plugin
module.exports = {"button":"PhotosLoadMore_button__1Y4VY"};